// First value is Make, second is model and this is year
var makeObject = {
  Audi: {
    "e-tron": ["2019", "2020", "2021", "2022", "2023"],
    "e-tron Sportback": ["2020", "2021", "2022", "2023"],
    "e-tron GT": ["2022", "2023"],
    "e-tron S Sportback": ["2022", "2023"],
    "Q4 e-tron": ["2022", "2023"],
    "Q4 e-tron Sportback": ["2022", "2023"],
    "RS e-tron GT": ["2022", "2023"],
  },
  BMW: {
    i4: ["2022", "2023"],
    iX: ["2022", "2023"],
  },
  Chevrolet: {
    "Bolt EUV": ["2022", "2023"],
    "Bolt EV": ["2017", "2018", "2019", "2020", "2021", "2022", "2023"],
  },
  Ford: {
    "F-150 Lightning": ["2022"],
    Focus: ["2012", "2013", "2014", "2015", "2016", "2017", "2018"],
    "Mustang Mach-E (AWD)": ["2021", "2022", "2023"],
    "Mustang Mach-E (RWD)": ["2021", "2022", "2023"],
    "Mustang Mach-E (GT Performance)": ["2021", "2022", "2023"],
  },
  Genesis: {
    "Electrified G80": ["2023"],
    "GV60 (Advanced)": ["2023"],
    "GV60 (Performance)": ["2023"],
    "GV70 EV": ["2023"],
  },
  Hyundai: {
    "IONIQ 5": ["2022", "2023"],
    "IONIQ 6": ["2023"],
    "IONIQ Electric": ["2018", "2019", "2020", "2021"],
    "Kona Electric": ["2019", "2020", "2021", "2022", "2023"],
  },
  Jaguar: {
    "I-Pace": ["2019", "2020", "2021", "2022", "2023"],
  },
  Kia: {
    EV6: ["2022", "2023"],
    "Niro EV": ["2019", "2020", "2021", "2022"],
    "Soul EV": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
  },
  Lucid: {
    Air: ["2022"],
  },
  Mazda: {
    "MX-30 EV": ["2022", "2023"],
  },
  Mercedes: {
    "EQB 350": ["2022"],
    "EQS 580": ["2022"],
  },
  Mini: {
    "Cooper (SE 3 Dr.)": ["2020", "2021", "2022", "2023"],
  },
  Nissan: {
    Ariya: ["2023"],
    "Ariya (Evolve)": ["2023"],
    "Ariya (Platinum)": ["2023"],
    "Ariya (Premier)": ["2023"],
    Leaf: ["2018", "2019", "2020", "2021", "2022", "2023"],
    "Leaf(S)": ["2015", "2016", "2017"],
    "Leaf(SL)": ["2015", "2016", "2017"],
    "Leaf(SV)": ["2011", "2012", "2013", "2014", "2015", "2016", "2017"],
  },
  Polestar: {
    "Polestar 2": ["2021", "2022", "2023"],
    "Polestar 2 (Performance)": ["2021", "2022", "2023"],
  },
  Porsche: {
    Taycan: ["2020", "2021", "2022", "2023"],
    "Polestar 2 (Performance)": ["2021", "2022", "2023"],
  },
  Tesla: {
    "Model 3 (AWD)": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "Model 3 (RWD)": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "Model 3 (Performance Dual Motor AWD)": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Model S": ["2013", "2014", "2015", "2016"],
    "Model S (100D)": ["2015", "2016"],
    "Model S (60)": ["2017"],
    "Model S (60D)": ["2017"],
    "Model S (75)": ["2017", "2018"],
    "Model S (75D)": ["2017", "2018"],
    "Model S (90D)": ["2017"],
    "Model S (Long Range)": ["2019", "2020"],
    "Model S (Ludicrous Performance)": ["2019", "2020"],
    "Model S (P100D)": ["2017", "2018"],
    "Model S (P90D)": ["2017"],
    "Model S (Plaid)": ["2021", "2022", "2023"],
    "Model X": ["2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    "Model Y": ["2020", "2021", "2022", "2023"],
  },
  Toyota: {
    Mirai: ["2019", "2020", "2021", "2022"],
  },
  Volkswagen: {
    "e-Golf": ["2018", "2019", "2020"],
    "ID.4": ["2021", "2022", "2023"],
    "ID.4 (AWD Pro)": ["2021", "2022", "2023"],
  },
  Volvo: {
    "C40 Recharge": ["2022"],
    XC40: ["2021", "2022"],
  },
};
